import Vue from "vue";
import VueRouter from "vue-router";
import DashboardView from "./components/Views/Dashboard";
import Welcome from "./components/Views/Welcome";
import BillingView from "./components/Views/Billing";
import SettingsView from "./components/Views/Settings";
import NotFound from "./components/Views/NotFound";

import ProjectDetail from "./components/Views/ProjectDetail";
import ProjectIndex from "./components/Project/Index";
import ProjectPriority from "./components/Project/Priority";
import ProjectUpload from "./components/Project/Upload";
import ProjectDownload from "./components/Project/Download";
import ProjectLogs from "./components/Project/Logs";
import ProjectDiscard from "./components/Project/Discard";
import ProjectRemoveFromQueue from "./components/Project/RemoveFromQueue";
import ProjectStopRendering from "./components/Project/StopRendering";

import BillingWelcome from "./components/Billing/Welcome";
import InvoiceDetail from "./components/Billing/InvoiceDetail";
import NewRefillCreator from "./components/Billing/NewRefillCreator";

Vue.use(VueRouter);

const routes = [
  // { path: "/:locale/app/projects/login", component: LoginForm },
  // { path: "/:locale/app/projects/register", component: RegisterForm },
  {
    path: "/:locale/app",
    redirect: "/:locale/app/projects",
    meta: {
      titleKey: "dashboard",
    },
  },
  {
    path: "/:locale/app/:type(projects|queue)",
    component: DashboardView,
    meta: {
      titleKey: "dashboard",
    },
    children: [
      {
        path: "",
        name: "welcome",
        component: Welcome,
      },
      {
        path: ":id(\\d+)",
        component: ProjectDetail,
        props: true,
        children: [
          {
            path: "",
            name: "project.index",
            component: ProjectIndex,
          },
          {
            path: "priority",
            name: "project.priority",
            component: ProjectPriority,
          },
          {
            path: "upload",
            name: "project.upload",
            component: ProjectUpload,
          },
          {
            path: "download",
            name: "project.download",
            component: ProjectDownload,
          },
          {
            path: "logs",
            name: "project.logs",
            component: ProjectLogs,
          },
          {
            path: "discard",
            name: "project.discard",
            component: ProjectDiscard,
          },
          {
            path: "remove",
            name: "project.remove",
            component: ProjectRemoveFromQueue,
          },
          {
            path: "stop",
            name: "project.stop",
            component: ProjectStopRendering,
          },
        ],
      },
    ],
  },
  {
    path: "/:locale/app/safe/:id",
    redirect: "/:locale/app/refills/:id",
    meta: {
      titleKey: "safe",
    },
  },
  {
    path: "/:locale/app/refills",
    component: BillingView,
    meta: {
      titleKey: "safe",
    },
    children: [
      {
        path: "",
        name: "invoice.welcome",
        component: BillingWelcome,
      },
      {
        path: "new",
        name: "invoice.new",
        component: NewRefillCreator,
      },
      {
        path: ":id(\\d+)",
        component: InvoiceDetail,
        name: "invoice.index",
        props: true,
      },
    ],
  },
  {
    path: "/:locale/app/settings",
    name: "settings",
    component: SettingsView,
    meta: {
      titleKey: "settings",
    },
  },
  {
    path: "/:locale/app/*",
    name: "404",
    component: NotFound,
    meta: {
      titleKey: "notFound",
    },
  },
  { path: "*", redirect: "/en/app/projects" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
